import { Navigate } from 'react-router-dom'

/**
 * /app/procurement/bookmarks merged into the board (spec M1): the old
 * bookmarks page is gone; the board at /app/procurement/tracking is the
 * one Suivi surface.
 */
export default function BookmarksRedirect() {
  return <Navigate to="/app/procurement/tracking" replace />
}
